import arrowCircleIcon from '@assets/atemporal/arrow-circle.png'
import { useAppStore, useUiPresentationStore } from '@store'
import { MODULAR_IKEA_DRAG_ENABLED } from '@utils/modularSnap/config'
import { useModularUiStore } from '@utils/modularSnap/modularUiStore'
import { rotateModularSection90 } from '@utils/modularSnap/rotateSection'
import { useState, type MouseEvent as ReactMouseEvent } from 'react'

const cloudStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '5px 9px',
  borderRadius: 999,
  background: 'rgba(255,255,255,0.98)',
  boxShadow: '0 6px 24px rgba(15,23,42,0.16)',
  border: '1px solid rgba(148,163,184,0.45)',
  pointerEvents: 'auto',
  userSelect: 'none',
}

const iconButtonStyle: React.CSSProperties = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  display: 'grid',
  placeItems: 'center',
  color: '#1e293b',
  fontSize: 24,
  lineHeight: 1,
  position: 'relative',
}

const tooltipStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: '100%',
  left: '50%',
  transform: 'translate(-50%, -10px)',
  background: '#111827',
  color: '#fff',
  padding: '6px 10px',
  borderRadius: 6,
  fontSize: 12,
  fontWeight: 600,
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
}

/** Nube IKEA de rotación — overlay 2D sobre el canvas. */
export function ModularSectionToolbarOverlay() {
  const toolbarScreenPos = useModularUiStore((s) => s.toolbarScreenPos)
  const isModalOpen = useAppStore.use.isModalOpen()
  const activeSheet = useUiPresentationStore((s) => s.activeSheet)
  const [hoverRotate, setHoverRotate] = useState(false)

  // No tapar sheets/modales: ocultar con panel touch abierto o modal (Atemporal 47ee2081).
  if (!MODULAR_IKEA_DRAG_ENABLED || isModalOpen || activeSheet || !toolbarScreenPos) return null

  const handleRotate = (e: ReactMouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    const state = useAppStore.getState()
    const item = state.items.get(String(toolbarScreenPos.targetId)) as any
    if (!item) return
    rotateModularSection90(
      toolbarScreenPos.targetId,
      {
        items: state.items,
        editItem: state.editItem,
        editItemAngle: state.editItemAngle,
        setOBB: state.setOBB,
        updateSelectedObjectsPosition: state.updateSelectedObjectsPosition,
        collisionableItems: state.collisionableItems,
        collideItems: state.collideItems,
        collidePouffItems: state.collidePouffItems,
      },
      { resnapToNearest: true },
    )
  }

  return (
    <div
      style={{
        position: 'fixed',
        left: toolbarScreenPos.x,
        top: toolbarScreenPos.y,
        transform: 'translate(-50%, calc(-100% - 20px))',
        // Por debajo de ModeBar (70) y sheets (80); por encima del canvas (Atemporal 47ee2081).
        zIndex: 25,
        pointerEvents: 'none',
      }}
    >
      <div
        style={cloudStyle}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <button
          type='button'
          aria-label='Girar sección'
          title='Girar sección'
          style={iconButtonStyle}
          onPointerDown={(e) => e.stopPropagation()}
          onMouseEnter={() => setHoverRotate(true)}
          onMouseLeave={() => setHoverRotate(false)}
          onClick={handleRotate}
        >
          {hoverRotate && <span style={tooltipStyle}>Girar sección</span>}
          <img
            src={arrowCircleIcon}
            alt=''
            draggable={false}
            style={{
              width: 24,
              height: 24,
              display: 'block',
              pointerEvents: 'none',
              transform: 'scaleX(-1)',
            }}
          />
        </button>
      </div>
    </div>
  )
}
